import { Grid } from "antd";
import { useSSRContext } from "../../context/SSRContext";
import { useTranslation } from "react-i18next";
import SSRContent from "../SSRContent/SSRContent";
import Carrier from "@Components/Carrier/Carrier";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { SSREntry } from "./components";
import clsx from "clsx";

export default function SSRChips() {
  const { t } = useTranslation();
  const { SSROptions, handleChange } = useSSRContext();
  const trigger = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const placement = trigger ? "right" : "bottom";
  const handleSSRChange = (value: string) => {
    handleChange("ssrType", value)();
  };
  return (
    <div className="flex w-full w-full flex-col gap-4">
      {SSROptions.map((option) => {
        return (
          <Carrier
            key={option?.value}
            renderSheet={() => (
              <div className="flex min-h-0 flex-1 flex-col">
                <SSRContent />
              </div>
            )}
            initialSize={trigger ? .6:.8}
            resizable={trigger}
            label={
              <div className="flex items-center gap-1">
                <span className="text-font-default bg-background-minimal flex size-8 items-center rounded-full p-2">{option?.icon}</span>
                <span className="font-semibold">{t("Flights.details.ssr.selectYourType", { type: option?.label })}</span>
              </div>
            }
            renderTrigger={({ open }) => (
              <SSREntry
                option={option}
                onClick={() => {
                  handleSSRChange(option?.value ?? "");
                  open();
                }}
              />
            )}
            placement={placement}
            className={clsx(trigger && "p-0! rounded-t-none!")}
          />
        );
      })}
    </div>
  );
}
